import { motion } from "framer-motion";
import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQS = [
  {
    q: "¿Necesito experiencia previa?",
    a: "No, nuestro sistema está diseñado para todos los niveles. Comenzamos desde cero con el rango Recluta y avanzamos progresivamente hasta Falcons. Cada rango te prepara para el siguiente con formación estructurada y práctica guiada.",
  },
  {
    q: "¿Las señales son en tiempo real?",
    a: "Disponemos de un canal con señales respaldadas por historial y análisis diario, además de sesiones en vivo cada mañana.",
  },
  {
    q: "¿Cómo accedo a cuentas fondeadas?",
    a: "A través de nuestra formación por rangos y acompañamiento podrás prepararte para pasar procesos de fondeo y acceder a cuentas apalancadas.",
  },
  {
    q: "¿Honor Trading tiene control de mi dinero?",
    a: "No. Honor Trading es una plataforma educativa y de acompañamiento. La operativa y gestión de fondos corre por cuenta del trader y/o proveedor de servicios que elija.",
  },
  {
    q: "¿Ofrecen soluciones de e-commerce?",
    a: "Nos enfocamos en educación de trading y sistemas de rendimiento. Para otros servicios podemos guiarte a partners confiables.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="relative py-24 md:py-32 bg-black" data-testid="faq-section">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="mb-14 max-w-3xl">
          <span className="text-xs font-display uppercase tracking-[0.4em] text-[#BEDD7D]">
            / FAQ
          </span>
          <h2 className="mt-6 font-display font-bold text-4xl md:text-6xl uppercase tracking-tight leading-none">
            Preguntas <span className="italic text-[#BEDD7D]">frecuentes</span>.
          </h2>
        </div>

        <div className="space-y-2">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.05 }}
                className="border-b border-[#3E4D36]/50"
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full py-6 flex items-center justify-between gap-6 text-left group"
                  data-testid={`faq-toggle-${i}`}
                  aria-expanded={isOpen}
                >
                  <span className="font-display font-bold text-lg md:text-2xl uppercase tracking-tight group-hover:text-[#BEDD7D] transition-colors">
                    {item.q}
                  </span>
                  <span
                    className={`shrink-0 w-10 h-10 rounded-full border flex items-center justify-center transition-all ${
                      isOpen
                        ? "bg-[#BEDD7D] border-[#BEDD7D] text-black"
                        : "border-[#3E4D36] text-[#BEDD7D]"
                    }`}
                  >
                    {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  </span>
                </button>
                <motion.div
                  initial={false}
                  animate={{ height: isOpen ? "auto" : 0, opacity: isOpen ? 1 : 0 }}
                  transition={{ duration: 0.35, ease: "easeInOut" }}
                  className="overflow-hidden"
                >
                  <p className="pb-6 text-white/70 font-body leading-relaxed max-w-3xl">
                    {item.a}
                  </p>
                </motion.div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
